import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

function AdminRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    // Check if admin token exists in localStorage
    const token = localStorage.getItem('admin_token');
    setIsAuthenticated(!!token);
  }, []);

  // Show nothing while checking
  if (isAuthenticated === null) {
    return null;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  // Render protected content
  return children;
}

export default AdminRoute;
